import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=6ea9bdd4&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=6ea9bdd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea9bdd4",
  null
  
)

export default component.exports